<template>
  <div>
    <div style="height: auto" class="d-flex justify-content-center align-items-center">
      <div class="register-wrapper col-xs-10 col-sm-9 col-md-8 col-4">
        <br>

        <div class="text-center">
          <router-link class="logo-router" :to="{name: 'Homepage'}">
            <img class="rounded logo-img" src="@/assets/images/umoney_logo.png">
          </router-link>
        </div>

        <br>

        <div v-if="this.getErrorMsg('form').length > 0" class="toast rounded">
          <p v-for="(message, i) in this.getErrorMsg('form')" :key="i">{{ message }}</p>
        </div>

        <br>
        <div class="text-right">
          <button
            @click="toggleLanguage"
            class="btn btn-sm btn--color-orange rounded"
          >{{ getCaption("caption.change_language_button") }}</button>
        </div>

        <form @submit.prevent="onFormSubmit" novalidate>
          <div class="form-group">
            <label class="form-label">{{ this.getCaption("caption.email") }}</label>
            <input
              class="form-input rounded text-center focus-purple"
              type="text"
              v-on:input="onChangeHandler('email', $v.email)"
              :class="{ 'is-error': $v.email.$error }"
              v-model="email"
            >
            <div v-if="!$v.email.serverFailed">
              <span class="error-msg__data">{{ this.getErrorMsg('email')[0] }}</span>
            </div>
          </div>

          <div class="form-group">
            <label class="form-label">{{ this.getCaption("caption.confirm_email") }}</label>
            <input
              class="form-input rounded text-center focus-purple"
              type="text"
              v-on:input="onChangeHandler('emailRe', $v.emailconfirm)"
              :class="{ 'is-error': $v.emailconfirm.$error }"
              v-model="emailconfirm"
            >
            <div v-if="!$v.emailconfirm.serverFailed">
              <span class="error-msg__data">{{ this.getErrorMsg('emailRe')[0] }}</span>
            </div>
          </div>

          <br>

          <label class="form-label">{{ this.getCaption("caption.password") }}</label>
          <div class="form-group has-icon-right">
            <input
              class="form-input rounded text-center form-input--right-icon focus-purple"
              type="password"
              v-on:input="onChangeHandler('password', $v.password)"
              :class="{ 'is-error': $v.password.$error }"
              v-model="password"
            >
            <i class="form-icon form-icon--right fas fa-lock"></i>
          </div>
          <div class="lined-error-msg" v-if="!$v.password.serverFailed">
            <span class="error-msg__data">{{ this.getErrorMsg('password')[0] }}</span>
          </div>

          <label class="form-label">{{ this.getCaption("caption.confirm_password") }}</label>
          <div class="form-group has-icon-right">
            <input
              class="form-input rounded text-center form-input--right-icon focus-purple"
              type="password"
              v-on:input="onChangeHandler('passwordRe', $v.passwordconfirm)"
              :class="{ 'is-error': $v.passwordconfirm.$error }"
              v-model="passwordconfirm"
            >
            <i class="form-icon form-icon--right fas fa-lock"></i>
            <i
              :class="{ 'form-icon--checked': $v.passwordconfirm.sameAsPassword && password !== '' }"
              class="form-icon form-icon--check fas fa-check"
            ></i>
          </div>
          <div class="lined-error-msg" v-if="!$v.passwordconfirm.serverFailed">
            <span class="error-msg__data">{{ this.getErrorMsg('passwordRe')[0] }}</span>
          </div>

          <div class="form-group">
            <div class="columns">
              <div class="form-element-pr col-xs-12 col-6 full-width">
                <label class="form-label">{{ this.getCaption("caption.last_name") }}</label>
                <input
                  class="form-input rounded text-center focus-purple"
                  type="text"
                  v-on:input="onChangeHandler('lastName', $v.lastname)"
                  :class="{ 'is-error': $v.lastname.$error }"
                  v-model="lastname"
                >
                <div v-if="!$v.lastname.serverFailed">
                  <span class="error-msg__data">{{ this.getErrorMsg('lastName')[0] }}</span>
                </div>
              </div>

              <div class="form-element-pl col-xs-12 col-6">
                <label class="form-label">{{ this.getCaption("caption.first_name") }}</label>
                <input
                  class="form-input rounded text-center focus-purple"
                  type="text"
                  v-on:input="onChangeHandler('firstName', $v.firstname)"
                  :class="{ 'is-error': $v.firstname.$error }"
                  v-model="firstname"
                >
                <div v-if="!$v.firstname.serverFailed">
                  <span class="error-msg__data">{{ this.getErrorMsg('firstName')[0] }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="form-group">
            <label class="form-label">{{ this.getCaption("caption.birth_date") }}</label>
            <div class="columns">
              <div class="pr-1 col-xs-5 col-6">
                <select
                  @change="onChangeHandler('birthdate', $v.birthdate)"
                  class="form-select rounded text-center form-select--placeholder focus-purple"
                  :class="{ 'is-error': $v.birthdate.$error }"
                  v-model="birthdate.year"
                  required
                >
                  <option value hidden disabled>{{ this.getCaption("caption.year") }}</option>
                  <option v-for="(year, i) in years" :key="i">{{ year }}</option>
                </select>
                <div v-if="!$v.birthdate.serverFailed">
                  <span class="error-msg__data">{{ this.getErrorMsg('birthdate')[0] }}</span>
                </div>
              </div>
              <div class="pl-1 col-xs-7 col-6">
                <div class="columns">
                  <div class="pr-1 col-6">
                    <select
                      @change="onChangeHandler('birthdate', $v.birthdate)"
                      class="form-select rounded text-center form-select--placeholder focus-purple"
                      :class="{ 'is-error': $v.birthdate.$error }"
                      v-model="birthdate.month"
                      required
                    >
                      <option value hidden disabled>{{ this.getCaption("caption.month") }}</option>
                      <option v-for="(month, i) in months" :key="i">{{ month }}</option>
                    </select>
                  </div>

                  <div class="pl-1 col-6">
                    <select
                      @change="onChangeHandler('birthdate', $v.birthdate)"
                      class="form-select rounded text-center form-select--placeholder focus-purple"
                      :class="{ 'is-error': $v.birthdate.$error }"
                      v-model="birthdate.day"
                      required
                    >
                      <option value hidden disabled>{{ this.getCaption("caption.day") }}</option>
                      <option v-for="(day, i) in days" :key="i">{{ day }}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="language === 'lang-eng'" class="form-group">
            <div class="columns">
              <div class="form-element-pr col-xs-12 col-6">
                <label class="form-label">{{ this.getCaption("caption.country") }}</label>
                <select
                  @change="onChangeHandler('country', $v.country)"
                  class="form-select rounded text-center form-select--placeholder focus-purple"
                  :class="{ 'is-error': $v.country.$error }"
                  v-model="country"
                  required
                >
                  <option value hidden disabled>{{ this.getCaption("caption.choose") }}</option>
                  <option v-for="(country, i) in countries" :key="i">{{ country }}</option>
                </select>
                <div v-if="!$v.country.serverFailed">
                  <span class="error-msg__data">{{ this.getErrorMsg('country')[0] }}</span>
                </div>
              </div>

              <div class="form-element-pl col-xs-12 col-6">
                <label class="form-label">{{ this.getCaption("caption.sex") }}</label>
                <select
                  @change="onChangeHandler('sex', $v.sex)"
                  class="form-select rounded text-center form-select--placeholder focus-purple"
                  :class="{ 'is-error': $v.sex.$error }"
                  v-model="sex"
                  required
                >
                  <option value hidden disabled>{{ this.getCaption("caption.choose") }}</option>
                  <option>{{ this.getCaption("caption.male") }}</option>
                  <option>{{ this.getCaption("caption.female") }}</option>
                </select>
                <div v-if="!$v.sex.serverFailed">
                  <span class="error-msg__data">{{ this.getErrorMsg('sex')[0] }}</span>
                </div>
              </div>
            </div>
          </div>

          <div v-if="language === 'lang-mon'" class="form-group">
            <label class="form-label">{{ this.getCaption("caption.sex") }}</label>
            <select
              @change="onChangeHandler('sex', $v.sex)"
              class="form-select rounded text-center form-select--placeholder focus-purple"
              :class="{ 'is-error': $v.sex.$error }"
              v-model="sex"
              required
            >
              <option value hidden disabled>{{ this.getCaption("caption.choose") }}</option>
              <option>{{ this.getCaption("caption.male") }}</option>
              <option>{{ this.getCaption("caption.female") }}</option>
            </select>
            <div v-if="!$v.sex.serverFailed">
              <span class="error-msg__data">{{ this.getErrorMsg('sex')[0] }}</span>
            </div>
          </div>

          <div class="form-group">
            <label class="form-label">{{ this.getCaption("caption.phone") }}</label>
            <input
              class="form-input rounded text-center focus-purple"
              type="text"
              maxlength="8"
              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
              v-on:input="onChangeHandler('phone', $v.phone)"
              :class="{ 'is-error': $v.phone.$error }"
              v-model="phone"
            >
            <div v-if="!$v.phone.serverFailed">
              <span class="error-msg__data">{{ this.getErrorMsg('phone')[0] }}</span>
            </div>
          </div>

          <div v-if="language === 'lang-mon'" class="form-group">
            <label class="form-label">{{ this.getCaption("caption.register_id") }}</label>
            <div class="registration-char form-inline">
              <select
                @change="onChangeHandler('registerId', $v.registerid)"
                class="form-select registration-char__input rounded text-center focus-purple"
                :class="{ 'is-error': $v.registerid.$error }"
                v-model="registerid.rgchar1"
              >
                <option v-for="(mnchar, i) in mnchars" :key="i">{{ mnchar }}</option>
              </select>
              <div v-if="!$v.registerid.serverFailed">
                <span class="error-msg__data">{{ this.getErrorMsg('registerId')[0] }}</span>
              </div>
            </div>

            <div class="registration-char form-inline">
              <select
                @change="onChangeHandler('registerId', $v.registerid)"
                class="form-select registration-char__input rounded text-center focus-purple"
                :class="{ 'is-error': $v.registerid.$error }"
                v-model="registerid.rgchar2"
              >
                <option v-for="(mnchar, i) in mnchars" :key="i">{{ mnchar }}</option>
              </select>
            </div>

            <div class="registration-num form-inline">
              <input
                class="form-input rounded text-center focus-purple"
                type="text"
                maxlength="8"
                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                v-on:input="onChangeHandler('registerId', $v.registerid)"
                :class="{ 'is-error': $v.registerid.$error }"
                v-model="registerid.rgnumber"
              >
            </div>
          </div>

          <div v-if="language === 'lang-eng'" class="form-group">
            <label class="form-label">{{ this.getCaption("caption.register_id") }}</label>
            <div class="registration-char form-inline">
              <select
                @change="onChangeHandler('registerId', $v.registerid)"
                class="form-select registration-char__input rounded text-center focus-purple"
                :class="{ 'is-error': $v.registerid.$error }"
                v-model="registerid.rgchar1"
              >
                <option v-for="(enchar, i) in enchars" :key="i">{{ enchar }}</option>
              </select>
              <div v-if="!$v.registerid.serverFailed">
                <span class="error-msg__data">{{ this.getErrorMsg('registerId')[0] }}</span>
              </div>
            </div>

            <div class="registration-char form-inline">
              <select
                @change="onChangeHandler('registerId', $v.registerid)"
                class="form-select registration-char__input rounded text-center focus-purple"
                :class="{ 'is-error': $v.registerid.$error }"
                v-model="registerid.rgchar2"
              >
                <option v-for="(enchar, i) in enchars" :key="i">{{ enchar }}</option>
              </select>
            </div>

            <div class="registration-char form-inline">
              <select
                @change="onChangeHandler('registerId', $v.registerid)"
                class="form-select registration-char__input rounded text-center focus-purple"
                :class="{ 'is-error': $v.registerid.$error }"
                v-model="registerid.rgchar3"
              >
                <option v-for="(enchar, i) in enchars" :key="i">{{ enchar }}</option>
              </select>
            </div>

            <div class="registration-num-f form-inline">
              <input
                class="form-input rounded text-center focus-purple"
                type="text"
                maxlength="10"
                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                v-on:input="onChangeHandler('registerId', $v.registerid)"
                :class="{ 'is-error': $v.registerid.$error }"
                v-model="registerid.rgnumber"
              >
            </div>
          </div>

          <div class="form-group">
            <label class="form-label">{{ this.getCaption("caption.email") }}</label>
            <div class="columns">
              <div class="pr-1 col-xs-7 col-8">
                <input
                  class="form-input rounded text-center focus-purple"
                  :value="$v.emailconfirm.sameAsEmail ? email : ''"
                  disabled
                >
              </div>
              <div class="pl-1 col-xs-5 col-4">
                <button
                  type="button"
                  @click="sendCode()"
                  class="btn btn--color-orange btn--width-full rounded"
                  :disabled="submitStatus === 'SENDING'"
                >
                  <div v-if="submitStatus === 'SENDING'" class="loader--sm"></div>
                  <span v-else>{{ this.getCaption("caption.send_code_button") }}</span>
                </button>
              </div>
            </div>
          </div>

          <div class="form-group">
            <label class="form-label">{{ this.getCaption("caption.verify_code") }}</label>
            <input
              class="form-input rounded text-center focus-purple"
              type="text"
              v-on:input="onChangeHandler('verificationCode', $v.verificationCode)"
              :class="{ 'is-error': $v.verificationCode.$error }"
              v-model="verificationCode"
            >
            <div v-if="!$v.verificationCode.serverFailed">
              <span class="error-msg__data">{{ this.getErrorMsg('verificationCode')[0] }}</span>
            </div>
          </div>

          <br>
          <h5>{{ getCaption("caption.terms_of_service.title") }}</h5>
          <textarea
            class="form-input form__textarea focus-purple"
            readonly
            v-html="getCaption('caption.terms_of_service.body')"
          ></textarea>
          <div class="form-group">
            <label class="form-checkbox">
              <input v-model="termsOfService" type="checkbox">
              <i class="form-icon"></i>
              {{ getCaption("caption.terms_of_service.checkbox") }}
            </label>
          </div>
          <br>

          <div class="form-group">
            <button
              class="btn btn--color-purple btn--width-full rounded"
              :disabled="submitStatus === 'PENDING' || submitStatus === 'SENDING' || !termsOfService"
            >
              <div v-if="submitStatus === 'PENDING'" class="loader--sm"></div>
              <span v-else>{{ this.getCaption("caption.register_button") }}</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { sameAs, required, requiredIf } from "vuelidate/lib/validators";
import UserService from "@/services/UserService";
import Form from "@/mixins/Form.js";
import countryList from "@/constants/countryList.json";

const range = (start, stop, step) =>
  Array.from({ length: (stop - start) / step }, (_, i) => start + i * step);

export default {
  name: "SignUp",

  mixins: [Form],

  data() {
    return {
      password: "",
      passwordconfirm: "",
      email: "",
      emailconfirm: "",
      lastname: "",
      firstname: "",
      birthdate: {
        year: "",
        month: "",
        day: ""
      },
      country: "",
      sex: "",
      phone: "",
      registerid: {
        rgchar1: "",
        rgchar2: "",
        rgchar3: window.localStorage.getItem("language") === "",
        rgnumber: ""
      },
      verificationCode: "",

      language: window.localStorage.getItem("language"),
      years: range(1900, new Date().getFullYear() + 1, 1).reverse(),
      months: range(1, 13, 1),
      days: range(1, 32, 1),
      mnchars: range("А".charCodeAt(0), "Я".charCodeAt(0) + 1, 1).map(x =>
        String.fromCharCode(x)
      ),
      enchars: range("A".charCodeAt(0), "Z".charCodeAt(0) + 1, 1).map(x =>
        String.fromCharCode(x)
      ),
      countries: countryList["countries"],
      termsOfService: false
    };
  },

  validations: {
    email: {
      required,
      serverFailed: function() {
        return !this.hasServerError("email");
      }
    },
    emailconfirm: {
      required,
      sameAsEmail: sameAs("email"),
      serverFailed: function() {
        return !this.hasServerError("emailRe");
      }
    },
    password: {
      required,
      serverFailed: function() {
        return !this.hasServerError("password");
      }
    },
    passwordconfirm: {
      required,
      sameAsPassword: sameAs("password"),
      serverFailed: function() {
        return !this.hasServerError("passwordRe");
      }
    },
    lastname: {
      required,
      serverFailed: function() {
        return !this.hasServerError("lastName");
      }
    },
    firstname: {
      required,
      serverFailed: function() {
        return !this.hasServerError("firstName");
      }
    },
    birthdate: {
      year: {
        required
      },
      month: {
        required
      },
      day: {
        required
      },
      serverFailed: function() {
        return !this.hasServerError("birthdate");
      }
    },
    country: {
      required: requiredIf(function() {
        return this.language === "lang-eng";
      }),
      serverFailed: function() {
        return !this.hasServerError("country");
      }
    },
    sex: {
      required,
      serverFailed: function() {
        return !this.hasServerError("sex");
      }
    },
    phone: {
      required,
      serverFailed: function() {
        return !this.hasServerError("phone");
      }
    },
    registerid: {
      rgchar1: {
        required
      },
      rgchar2: {
        required
      },
      rgchar3: {
        required: requiredIf(function() {
          return this.language === "lang-eng";
        })
      },
      rgnumber: {
        required
      },

      serverFailed: function() {
        return !this.hasServerError("registerId");
      }
    },
    verificationCode: {
      required,
      serverFailed: function() {
        return !this.hasServerError("verificationCode");
      }
    }
  },

  mounted() {
    this.$store.dispatch(
      "setPageTitle",
      this.getCaption("caption.register_button")
    );
  },

  methods: {
    onFormSubmit() {
      if (this.submitStatus !== "SENDING" && this.termsOfService)
        this.onSubmit();
    },

    sendCode() {
      if (!this.checkSendCode()) {
        this.submitStatus = "SENDING";
        const data = this.createJsonData();
        UserService.sendCode({}, data)
          .then(response => {
            if (response.status == 200 && response.data.success == true) {
              if (response.data.payload.toast !== null)
                this.showToast(
                  this.getCaption(response.data.payload.toast),
                  true
                );
            }
            this.submitStatus = "";
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.serverErrors = error.response.data.payload.errors;
              this.checkSendCode();
            }
            this.submitStatus = "";
          });
      }
    },

    checkSendCode() {
      let models = [
        this.$v.password,
        this.$v.passwordconfirm,
        this.$v.email,
        this.$v.emailconfirm,
        this.$v.lastname,
        this.$v.firstname,
        this.$v.birthdate.year,
        this.$v.birthdate.month,
        this.$v.birthdate.day,
        this.$v.country,
        this.$v.sex,
        this.$v.phone,
        this.$v.registerid.rgchar1,
        this.$v.registerid.rgchar2,
        this.$v.registerid.rgchar3,
        this.$v.registerid.rgnumber
      ];
      let invalid = false;
      models.forEach(function(model) {
        model.$touch();
        invalid = model.$invalid;
      });
      return invalid;
    },

    toggleLanguage() {
      let currentLanguage = window.localStorage.getItem("language");
      let otherLanguage =
        currentLanguage == "lang-mon" ? "lang-eng" : "lang-mon";
      window.localStorage.setItem("language", otherLanguage);
      window.location.reload();
    },

    serverRequest: UserService.register,

    successHandler() {
      this.$router.push({ name: "SignIn" });
    },

    createJsonData() {
      const data = JSON.parse("{}");
      data.lastName = this.lastname;
      data.firstName = this.firstname;
      data.birthdate = this.getBirthDate();
      data.sex =
        this.sex === ""
          ? ""
          : this.sex === this.getCaption("caption.male")
          ? 0
          : this.sex === this.getCaption("caption.female")
          ? 1
          : 2;
      data.phone = this.phone;
      data.registerId = this.getRegistrationNumber();
      data.email = this.email;
      data.emailRe = this.emailconfirm;
      data.password = this.password;
      data.passwordRe = this.passwordconfirm;
      data.country = this.language === "lang-mon" ? "Mongolia" : this.country;
      data.verificationCode = this.verificationCode;
      return data;
    },

    getBirthDate() {
      return (
        this.birthdate.year +
        "-" +
        this.birthdate.month +
        "-" +
        this.birthdate.day
      );
    },

    getRegistrationNumber() {
      return this.language === "lang-mon"
        ? this.registerid.rgchar1 +
            this.registerid.rgchar2 +
            this.registerid.rgnumber
        : this.registerid.rgchar1 +
            this.registerid.rgchar2 +
            this.registerid.rgchar3 +
            this.registerid.rgnumber;
    }
  }
};
</script>